import { getVaultConfig } from './get-vault-config';

interface IMakeVaultRawRequestParams {
  method: 'GET' | 'POST';
  path: string;
  body?: unknown;
  baseUrl?: string;
}

export async function makeVaultRawRequest({
  method,
  path,
  body,
  baseUrl,
}: IMakeVaultRawRequestParams): Promise<Response> {
  const { vaultUrl, apiKey } = getVaultConfig();
  const url = `${baseUrl ?? vaultUrl}${path}`;

  const headers: Record<string, string> = {
    // biome-ignore lint/style/useNamingConvention: HTTP header
    Authorization: `Bearer ${apiKey}`,
  };

  if (method === 'POST') {
    headers['Content-Type'] = 'application/json';
  }

  return fetch(url, {
    method,
    headers,
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
}
